import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { MsoTable } from "./MsoTable";
import { ListItem } from "../../Model/ListItem";
import { app } from "../../Frame/App";

export class ColumnBool extends ColumnBase {

    public getContent(row: any): HTMLElement {
        let value = row[this.def.dataField];
        if ((value as boolean) == true || value == "True") {
            return <i className="fa fa-check"></i>;
        }
        return null;
    }

    public getUniqueVisibleItems(table: MsoTable): Array<ListItem> {
        let result = new Array<ListItem>();
        let dict: { [id: string]: number } = {};
        for (let model of this.getRowModelsForFilter(table)) {
            let text = model[this.field];
            if (typeof (text) == 'boolean')
                text = model[this.field] ? "True" : "False";

            if (!(text in dict)) {
                dict[text] = 1;
            }
        }
        for (let text in dict) {
            result.push({ id: text, name: text });
        }
        return result;
    }

    public isFilterVisible(model: any): boolean {
        if (this.filteredItems) {
            let value = model[this.field];
            if (typeof (value) == 'boolean')
                value = model[this.field] ? "True" : "False";

            return value in this.filteredItems;
        }
        return true;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        let cell = super.createCell(rowModel, idField);

        this.initInlineEdit(rowModel, idField, cell);

        return cell;
    }

    protected initInlineEdit = (rowModel: any, idField: string, cell: HTMLElement) => {
        if (this.isEditable && rowModel[this.field] == false) {
            cell.classList.add("mt-textedit");

            let modelId = rowModel[idField];

            cell.addEventListener("click", () => {
                if (confirm(Resources.Common.columnStatusFinishedAsk)) {
                    app.showWaitPanel();
                    this.table.inlineEdit.saveValue(modelId, this.field, "true").done(() => {
                        app.hideWaitPanel();
                        cell.classList.add("mt-in-update");
                        this.table.updateRow(modelId, () => {
                            cell.classList.remove("mt-in-update");
                        });
                    }).fail(() => {
                        app.hideWaitPanel();
                    });;
                }
            });
        }
    }
}